let loadedPlayer = false;

window.addEventListener('DOMContentLoaded', function () {
    // Get the container of the iframe
    const videoContainer = $('.videoplayer').first() || $('.autoplay-video').first();
    
    if (videoContainer.length !== 0) {
        window.addEventListener('scroll', function () {
            if(inViewport(videoContainer.get(0))) {
                loadPlayer(videoContainer);
            }
        });
    }
});

function loadPlayer(element) {
    if (loadedPlayer) {
        return;
    }

    loadedPlayer = true;
    
    const config = element.hasClass('videoplayer') ? {hideControls: true,} : {hideControls: true, muted:true, autoplay:true, previewThumbnails: { enabled: false }, loop:{ active:true },};
    const player = new Plyr(element, config);
    
    player.on('ready', function () {
        // Timeout is used because YouTube logo is shown for a split second
        setTimeout(function () {
            $('#video-thumbnail-container').hide();
            $('#video-player').css('visibility', 'visible');
        }, 200);
    });
}

function inViewport (element) {
    if (!element) return false;
    if (1 !== element.nodeType) return false;
  
    var html = document.documentElement;
    var rect = element.getBoundingClientRect();
  
    return !!rect &&
      rect.bottom >= 0 &&
      rect.right >= 0 && 
      rect.left <= html.clientWidth &&
      rect.top <= html.clientHeight + 2000;
}